import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { LayoutDashboard, Users, LogOut, Zap, ExternalLink } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_house-rewire/artifacts/7meozpw2_LOGO%20-%20NO%20BACKGROUND.png";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  const navLinkClass = ({ isActive }) =>
    `flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
      isActive
        ? "bg-[#F5C518]/10 text-[#F5C518]"
        : "text-gray-400 hover:text-white hover:bg-white/5"
    }`;

  return (
    <div className="min-h-screen bg-[#0f0f10]" data-testid="admin-layout">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0f0f10]/95 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="LK Electrical & Security" className="h-9 w-auto" data-testid="admin-logo" />
            </div>

            <nav className="flex items-center gap-2">
              <NavLink to="/admin" end className={navLinkClass} data-testid="nav-dashboard">
                <LayoutDashboard className="w-4 h-4" />
                <span className="hidden sm:inline">Dashboard</span>
              </NavLink>
              {user?.role === "admin" && (
                <NavLink to="/admin/team" className={navLinkClass} data-testid="nav-team">
                  <Users className="w-4 h-4" />
                  <span className="hidden sm:inline">Team</span>
                </NavLink>
              )}
              <a
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                className="hidden sm:flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-gray-400 hover:text-white hover:bg-white/5 transition-colors"
                data-testid="nav-view-site"
              >
                <ExternalLink className="w-4 h-4" />
                View Site
              </a>
              <div className="w-px h-6 bg-white/10 mx-1 hidden sm:block" />
              <div className="hidden md:block text-right mr-2">
                <p className="text-white text-sm font-medium leading-tight" data-testid="current-user-name">{user?.name}</p>
                <p className="text-gray-500 text-xs capitalize" data-testid="current-user-role">{user?.role}</p>
              </div>
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium text-gray-400 hover:text-red-400 hover:bg-red-500/10 transition-colors"
                data-testid="logout-button"
                aria-label="Sign out"
              >
                <LogOut className="w-4 h-4" />
              </button>
            </nav>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
}
